import { graphql } from "gatsby";
import * as React from "react";
import { SEO } from "../components";
import { BlueContainer, PageTemplateContainer } from "../containers";
import { MainLayout } from "../layouts";

const PrivacyPolicy = ({ data }) => {
  return (
    <MainLayout>
      <div className="page-template">
        <BlueContainer
          title="Privacy Policy"
          className="page-template__header"
        />
        <PageTemplateContainer
          data={data.allMarkdownRemark.edges[0].node.html}
        />
      </div>
    </MainLayout>
  );
};

export const Head = ({ location }) => (
  <SEO
    title="Privacy Policy"
    description="Our Privacy Policy outlines how we safeguard your data and ensure complete confidentiality for your law firm’s automated email & SMS campaigns."
    pathname={location.pathname}
  />
);

export const query = graphql`
  query PrivacyPolicy {
    allMarkdownRemark(filter: { fileAbsolutePath: { regex: "/(policy)/" } }) {
      edges {
        node {
          frontmatter {
            title
            date(formatString: "DD/MM/YYYY")
          }
          html
        }
      }
    }
  }
`;

export default PrivacyPolicy;
